<template>
    <div>
      <CRUDCriteria :showReset="true" :showSearch="false">
        <template v-slot:criteriaRows>
            <v-row class="mr-6 ml-6 mb-n6">
                <v-col cols='2'>
                    <ClarionDateControl class=""
                    :isRequired="false" :isToggle="false"
                    label="Warrant Date"
                    v-model="criteriaState.remitWarrantDate"
                    @blurred="searchByCriteria('warrantDate')" />
                    </v-col>
                    <v-col cols="3" class="mt-6">
                      <v-select
                      class="input-text-size"
                      label="Tax Unit"
                      :items="toUnitDescList"
                      item-text="toUnitDesc"
                      v-model="criteriaState.toUnitDescForAppro"
                      item-value="toUnitDescForAppro"
                      @change="searchByCriteria"
                    >
                    </v-select>
                    </v-col>
                    <v-col cols="1" class="mt-6">
                    <span>Wildcard Search</span>
                    </v-col>
                    <v-col cols="2">
                    <v-text-field  class=" ml-n4"></v-text-field>
                    </v-col>
            </v-row>
            </template>
      </CRUDCriteria>
    </div>
  </template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import CRUDCriteria from '../common/base/crud-2.0/CRUDCriteria.vue';
import '../../assets/style.css';
import { makeCriteriaStateNullIfEmptyString } from '../tax/common-utils/CommonTaxFunctionalities';
// import { toIsoDate } from '../../util/shared/tmc-global';

export default {
  data() {
    return {
      taxUnitCrudKey: 'sharedTaxUnit',
    };
  },
  created() {
    this.loadLists();
    this.getCriteria();
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  components: {
    ClarionDateControl,
    CRUDCriteria,
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'items']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    toUnitDescList() {
      const unitDescObj = this.items(this.taxUnitCrudKey) || [];
      const updatedUnitDescObj = unitDescObj.map((u) => ({
        ...u,
        toUnitDesc: `${u.toUnitDescForAppro || ''}  ${u.description || ''}`,
      }));
      return [{ _id: null, toUnitDescForAppro: '', toUnitDesc: '' }, ...updatedUnitDescObj];
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions('shared/taxUnit', [
      'loadTaxUnit',
    ]),
    searchByCriteria(fromWhere) {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      this.$emit('loadCRUDList', fromWhere);
    },
    getCriteria() {
      const res = this.criteria('approtionmentTab');
      if (res) {
        this.criteriaState.remitWarrantDate = res.warrantDate;
      }
    },
    async loadLists() {
      await this.loadTaxUnit({
        criteria: {
        },
        baseCrudKey: 'sharedTaxUnit',
      });
    },
  },
};
</script>

<style scoped>
.align-right {
  display: flex;
  justify-content: end;
  /* margin-top: 1rem; */
}
</style>
